var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1674_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 11.9458C16.8413 11.9458 17.5232 11.2639 17.5232 10.4228C17.5232 9.58168 16.8413 8.89979 16.0002 8.89979C15.1591 8.89979 14.4772 9.58168 14.4772 10.4228C14.4772 11.2639 15.1591 11.9458 16.0002 11.9458Z",
    fill: "#90205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.00064H7.99994C5.77623 4.01822 3.98664 5.83289 3.99995 8.05664V20.2266C3.98664 22.4505 5.77609 24.2655 7.99994 24.2836H10.9229L14.6709 27.4836C15.4133 28.1621 16.5477 28.172 17.3019 27.5066L21.1469 24.2826H23.9999C26.2238 24.2645 28.0132 22.4495 27.9999 20.2256V8.05664C28.0133 5.83289 26.2237 4.01822 24 4.00064ZM16 7.04264C20.6149 7.16466 20.614 14.0197 16 14.1427C11.385 14.0196 11.386 7.16761 16 7.04264ZM20.2489 21.2086C19.7138 21.3452 19.1693 21.022 19.0328 20.4869C19.0322 20.4845 19.0315 20.4821 19.0309 20.4796C18.5191 18.8054 16.7469 17.8631 15.0727 18.3749C14.0649 18.683 13.276 19.4718 12.9679 20.4796C12.8282 21.0142 12.2815 21.3344 11.7469 21.1946C11.2123 21.0549 10.8922 20.5082 11.032 19.9736C11.8052 17.2296 14.6565 15.632 17.4005 16.4052C19.13 16.8926 20.4816 18.2442 20.9689 19.9736C21.1082 20.5131 20.787 21.064 20.2489 21.2086Z",
    fill: "#90205D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1674_6182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconSelected);
export default __webpack_public_path__ + "static/media/chatIcon-Selected.9268e525.svg";
export { ForwardRef as ReactComponent };